import { Icons } from "assets/icons";
import { useSmartBack } from "hooks/useSmartBack";
import React, { useEffect, useRef } from "react";
import gsap from "utils/gsap";

const PageHeader = ({ title, subtitle, isBackBtn = false }) => {
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const { arrowRight } = Icons;
  const goBack = useSmartBack();

  useEffect(() => {
    gsap.fromTo(
      titleRef.current,
      { opacity: 0, y: 8 },
      {
        opacity: 1,
        y: 0,
        duration: 0.35,
        ease: "power2.out",
      },
    );

    gsap.fromTo(
      subtitleRef.current,
      { opacity: 0, y: 6 },
      {
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: "power2.out",
        delay: 0.1,
      },
    );
  }, []);

  return (
    <div className="page_header">
      <div className="page_header_wrapper">
        <div className="d-flex align-content-center">
          {isBackBtn && (
            <img
              src={arrowRight}
              width={24}
              height={24}
              alt="icon"
              onClick={goBack}
            />
          )}
          {title && (
            <h4
              ref={titleRef}
              className={`${isBackBtn ? "add_edit_form" : ""} page_title`}
              style={{ opacity: 0 }}
            >
              {title}
            </h4>
          )}
        </div>
        {subtitle && (
          <p
            ref={subtitleRef}
            className="page_sub_title"
            style={{ opacity: 0 }}
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
